import request from '@/api/config/request'

export function login(data) {
    return request({
        url: 'login',
        method: 'post',
        data
    })
}

export function getUserInfo(options = {}) {
    return request({
        url: 'usuario',
        method: 'get',
        params: options
    })
}

export function setUsuario(data) {
    return request({
        url: 'register',
        method: 'post',
        data
    })
}

export function getConfirmacao(tus_codigo) {
    return request({
        url: `confirmacao/${tus_codigo}`,
        method: 'get'
    })
}

export function setConfirmacao(data) {
    return request({
        url: `confirmacao`,
        method: 'post',
        data
    })
}

export function setSolicitacaoRecuperacao(data) {
    return request({
        url: 'recover',
        method: 'post',
        data
    })
}

export function setReenviaConfirmacao(data) {
    return request({
        url: `reenvia/confirmacao`,
        method: 'post',
        data
    })
}

export function setRecover(ahr_hash, data) {
    return request({
        url: `recover/${ahr_hash}`,
        method: 'post',
        data
    })
}

